import { migrateLinkedDatasetIds } from "@/store/migrations/migrateLinkedDatasetIds";
import { tabStorage } from "@/store/tabStore/storage";

import { MIGRATION_KEYS } from "./constant";

// Global clean up function to remove all migration keys from storage after the migration is completed.
const ALL_MIGRATION_KEYS = Object.values(MIGRATION_KEYS);
const cleanUpLocalForage = async () => {
  await Promise.all(
    ALL_MIGRATION_KEYS.map((key) => tabStorage.removeItem(key))
  );
};

// This function will be called in the onBeforeLift prop of PersistGate to ensure that the migration is completed before the app is rendered.
export const handleBeforeLift = async () => {
  try {
    await migrateLinkedDatasetIds();
  } catch (e) {
    console.error("[onBeforeLift] Migration failed:", e);
  } finally {
    await cleanUpLocalForage();
  }
};
